const HomePage = () => {
  return <p>you are in home page</p>;
};
export default HomePage;
